module.exports = (__parcel__import__("5eO4E")).then(() => parcelRequire('g36Vt'));